export default __webpack_public_path__ + "static/media/Kaan-Mac.481243dc.webp";